<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="x1PART-NUM" id="par1"><a href="#/text/9780062131829_Contents#par_1">PART ONE</a></p>
<p class="x1PART-TTL"><a href="#/text/9780062131829_Contents#par_1"><span class="bolditalic">Blonde Pride</span></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062131829_Part_1.vue?b2f20570